module.exports = __webpack_public_path__ + "static/media/facebook.a64a1d0a.svg";